import {ComplianceAnnouncement} from "../../types";

export const HEADER_TEXT = 'Compliance Announcements'
export const DELETE = 'Delete'
export const EDIT = 'Edit'

export const NAME = {
  TITLE: 'Name',
  SUBTITLE: 'A unique, descriptive name for your announcement.'
}

export const DESCRIPTION = {
  TITLE: 'Description',
  SUBTITLE: 'Add a description to this compliance announcement.'
}

export const UPLOAD = {
  TITLE: 'Upload',
  SUBTITLE: 'Upload your custom compliance announcement that users can play back during a call.',
  LABEL_BUTTON: 'Select File'
}

export const NO_RESULT_STATE = {
  title: 'Add your first Announcement',
  subtitle: 'Looks like you haven’t created any announcements. Click the “Add Announcement” button to get started!'
}

export const TARGETING = {
  TITLE: 'Announcement Targeting',
  SUBTITLE: 'Target specific groups of users who can use this announcement.',
  LABEL: 'Announcement Targeting group',
  PLACEHOLDER: 'Select',
  ADVANCED: {
    HIDE: 'Hide Advanced Options',
    SHOW: 'Show Advanced Options'
  },
  USERS: {
    LABEL: 'Add Users',
    PLACEHOLDER: 'Enter User Names Here'
  },
  SF_PROFILES: {
    LABEL: 'Add Profiles',
    PLACEHOLDER: 'Enter Profile Names Here'
  },
  SF_ROLES: {
    LABEL: 'Add Roles',
    PLACEHOLDER: 'Enter Roles Here'
  },
  TEAMS: {
    LABEL: 'Add Teams',
    PLACEHOLDER: 'Enter Team Names Here'
  },
  EXClUDE_USERS: {
    TITLE: 'EXCLUDES',
    PLACEHOLDER: 'Select Users'
  }
}

export const initComplianceAnnouncements: ComplianceAnnouncement = {
  id: undefined,
  isPlaying: false,
  name: '',
  audioUrl: '',
  createdDate: 0,
  description: '',
  updatedDate: 0,
  targetingType: '',
  targetObjects: [],
  excludeUsers: []
}
